import { render, staticRenderFns } from "./merchantInvoices.vue?vue&type=template&id=2972debd&"
import script from "./merchantInvoices.vue?vue&type=script&lang=js&"
export * from "./merchantInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports